import React, { useEffect, useState } from "react";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { default as Select, components }  from "react-select";
import $ from "jquery";
import * as ReactDOM from 'react-dom';
import "datatables.net";
import { useNavigate,useHistory } from "react-router-dom";
import axios from 'axios';
import {getFilenameFromURL,getUsername,replaceSpacesWithUnderscores,capitalizeFirstLetterOfEachWord} from "../../utils/common_functions"
import {API_SERVER_URL} from "../../utils/config_ip_details";
import {API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE,CONTRACT_POLLING_MAX_COUNT,CONTRACT_STATUS_CHECK_POLLING_DURATION} from "../../utils/config_mapping"
import {apiCall} from "../../utils/server_utils"
import CommonIcon from '../common/customicon';
import PageLoader from '../common/pageloader';
import ProcessLoader from '../common/processloader';
import "../../../node_modules/datatables.net-dt/css/dataTables.dataTables.css";
import {trackError} from "../../utils/error_tracker"
import {OVERVIEW_META_DATA} from "../../utils/config_mapping";

export const Document = () => {
  
  let pollingInterval = null; // Store the interval for polling
  let pollingCount = 0; // Track the number of polling attempts

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const [adddocumentmodal, setAddDocumentModal] = useState(false);
  const handleClose = () => setAddDocumentModal(false);
  const handleShow = () => setAddDocumentModal(true);

  const [deletedocumentmodal, setDeleteDocumentModal] = useState(false);
  const handleDeleteClose = () => setDeleteDocumentModal(false);
  const handleDeleteShow = () => setDeleteDocumentModal(true);

  const [loading, setLoading] = useState(true); // State to track loading
  const [data, setData] = useState([]); // State to hold API data
  const [licensorOptions, setLicensorOptions] = useState([]); // Licensor dropdown options
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]); // Document Type dropdown options
  const [masterDocumentOptions, setMasterDocumentOptions] = useState([]); // Document Type dropdown options
  const statusoptions =[{label:"Success",value:"Success"},{label:"Error",value:"Error"},{label:"Running",value:"Running"}]
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({
  filterdocumentType: null,
  filterlicensor: null,
  filterexpiryDate: "",
  filterstatus: null,
  filterTextSearch: ""
});

  const initialState = {
    licensor: null,
    documentType: null,
    masterFile: "",
    documentFile: null,
    contractNo:"",
  }
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // Fetch Licensor and Document Type data
  useEffect(() => {
      const fetchDropdownData = async () => {
        try {
          let apiUrl = API_SERVER_URL+ 'licensors/'
          let method = "GET"
          const result = await apiCall(method,apiUrl);
          if(result!==undefined){
          if (result.code === API_SUCCESS_RESPONSE_CODE) {
            setLicensorOptions([
              // { value: "", label: "Select a Licensor" }, // Add an empty option
              ...result.data.map((item, i) => ({
                value: item.licensorName,
                label: item.licensorName,
              })),
            ]);
          } else {
            trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
          }
          }

         //#--  Master Document List 
         try {
         let apiMasterDocumentUrl = API_SERVER_URL+ 'documents/master/'
          let methodMasterDocument = "GET"
          let resultMasterDocuemnts = await apiCall(methodMasterDocument,apiMasterDocumentUrl);
          if(resultMasterDocuemnts!==undefined){
          if (resultMasterDocuemnts.code === API_SUCCESS_RESPONSE_CODE) {
            setMasterDocumentOptions([
              // { value: "", label: "Select a Licensor" }, // Add an empty option
              ...resultMasterDocuemnts.data.map((item, i) => ({
                value: item.BioworldDocumentNo,
                label: getFilenameFromURL(item.FilePath),
              })),
            ]);
          } else {
             trackError("The API response is invalid:<br/>URL:"+apiMasterDocumentUrl+"<br/>Method:"+methodMasterDocument+"<br>", JSON.stringify(resultMasterDocuemnts))
          }
          }
        } catch (error) {
          console.error("Error fetching dropdown data:", error);
        }
        //#--

           let apiDocumentTypeUrl = API_SERVER_URL+ 'documents/types/'
           let methodDocumentType = "GET"
           let resultDocumentType = await apiCall(methodDocumentType,apiDocumentTypeUrl);
          if(resultDocumentType!==undefined){
          if (resultDocumentType.code === API_SUCCESS_RESPONSE_CODE) {
            setDocumentTypeOptions([
              // { value: "", label: "Select a Licensor" }, // Add an empty option
              ...resultDocumentType.data.map((item, i) => ({
                value: item.documentTypeName,
                label: item.documentTypeName,
              })),
            ]);
          } else {
            trackError("The API response is invalid:<br/>URL:"+apiDocumentTypeUrl+"<br/>Method:"+methodDocumentType+"<br>", JSON.stringify(resultDocumentType))
          }
          }
        } catch (error) {
          console.error("Error fetching dropdown data:", error);
        }
      };
      fetchDropdownData();
    }, []);

    const handleView = (id,name) => {
       const fileName = getFilenameFromURL(name);
       navigate("/document-details/"+id+"/"+fileName+"/view")
        console.log("View button clicked for ID:", id);
    };


    const handleAskgenie = (id,name) => {
      const fileName = getFilenameFromURL(name);
      navigate("/document-details/"+id+"/"+fileName+"/askgenie")
       console.log("View button clicked for ID:", id);
   };

    const handleDelete = async (event) => {
      const dataId = event.target.getAttribute('data-id');
      if(dataId){
        let apiUrl = API_SERVER_URL+ 'contracts/'+dataId+'/delete/'
        let method = "POST"
        try {
            const result = await apiCall(method,apiUrl);
            if(result!==undefined){
            if (result.code === API_SUCCESS_RESPONSE_CODE) {
              handleDeleteClose()
              fetchData();
            } else {
              trackError("The API response is invalid:<br/>URL:"+apiUrl+"<br/>Method:"+method+"<br>", JSON.stringify(result))
            }
            }
        } catch (error) {
          console.error("Error refreshing token:", error);
        }
      }
    };

    const fetchData = async () => {
      $(".page_pro_load").hide();
      setLoading(true); // Stop loading spinner
      try {
        const result = await apiCall("GET", `${API_SERVER_URL}contracts/`);
        if (result.code === API_SUCCESS_RESPONSE_CODE) {

        // Extract _id values where StatusCode is "Running"
        const ids = result.data
        .filter(item => item.status && item.status.StatusCode === "Running")
        .map(item => item._id);
      
        // If there are IDs with StatusCode "Running", start polling for status
        if (ids.length > 0) {
          const id_comma_separated = ids.join(',');
          pollForStatus(id_comma_separated);
        }
          setData(result.data);
          setFilteredData(result.data); // Set initial data for filtering
         
        } else {
          console.warn("Unexpected response status:", result.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      finally {
         setLoading(false); // Stop loading spinner
     }
    };
 useEffect(() => {
      fetchData();
 }, []); // Empty dependency array ensures this runs only once
  

 


 const pollForStatus = (id_comma_separated) => {
  // Clear any previous interval to prevent multiple polling instances
  if (pollingInterval) {
    clearInterval(pollingInterval);
  }
  pollingCount = 0; // Reset polling count before starting
  // Start polling every 30 seconds
  pollingInterval = setInterval(async () => {
    if (pollingCount >= CONTRACT_POLLING_MAX_COUNT) {
      console.warn("Max polling attempts reached. Stopping polling.");
      clearInterval(pollingInterval);
      return;
    }

    try {
      const result_status_check = await apiCall("GET", `${API_SERVER_URL}contracts/status/?id_list=` + id_comma_separated);

      if (result_status_check.code === API_SUCCESS_RESPONSE_CODE) {
        // Check if any of the statuses is "Success"
        const successFound = result_status_check.data.some(item => item.status.StatusCode === "Success");
        if (successFound) {
          console.log("Success found! Fetching data...");
          clearInterval(pollingInterval); // Stop polling once success is found
          await fetchData(); // Call fetchData when "Success" is found
        }
      } else {
        console.warn("Unexpected response status in status check:", result_status_check.status);
      }
    } catch (error) {
      console.error("Error during status check:", error);
    }

    pollingCount++; // Increment polling count after each attempt
  }, CONTRACT_STATUS_CHECK_POLLING_DURATION); // Poll every 30 seconds
};



  useEffect(() => {
    if (filteredData.length > -1) {
      const table = $("#contract_grid").DataTable({
        scrollCollapse: true,
        scrollX: true,
        pageLength: 25, // Set default number of records per page
        scrollY:$(window).height()-($("#table_height").height()+180),
        data: filteredData,
        destroy: true, // Ensure the previous table is destroyed
        order: [],  // This disables default sorting on any column
        columns: [
          
          { data: "BioworldDocumentNo", title: "DocumentNo",width: "40px", },
          {
            data: "FilePath",
            title: "Document Name",
            width: "200px",
            render: function (data, type, row) {
              return `<a href="javascript:void(0);" class="view-btn" data-id="${row._id}" data-name="${row.FilePath}" data-status="${row.status.StatusCode}">
                        ${getFilenameFromURL(data)} <i class="datatable-open-document-icon"></i
                      </a>`;
            }
          },
          { data: "ContractID", title: "Contract ID", width: "40px"},
          {
            data: "status",
            title: "Status",
            width: "40px",
            render: function (data, type, row) {
              let status = data.StatusCode;
              // Check if data.StatusCode is undefined or null before calling toLowerCase
              if (status !== undefined && status !== null) {
                status = status.toLowerCase();
              } else {
                // Handle undefined or null case if needed
                status = 'unknown'; // Or any default value
              }
              //return status;
              if (status === "success") {
                return `<span className="badge bg-success">Success</span>`;
  //               return `  <div class="notification-card error">
  //   <h4>Database Connection Failed</h4>
  //   <p><strong>Code:</strong> DB.001</p>
  //   <p>Unable to establish connection with the primary database server</p>
  //   <p><strong>Source:</strong> Database Service</p>
  //   <span class="timestamp">Dec 15, 2024 09:07</span>
  // </div>`
              } else if (status === "error") {
                return `<span className="badge bg-danger">Failed</span>`;
              } else {
                return `<span className="badge bg-warning">Running</span>`;
              }
            }
          },
          { data: "documenttype", title: "Document Type", width: "10px" },
          { data: "importdate", title: "Imported Date", width: "10px" },
          { data: "licensor", title: "Licensor", width: "10px" },
          // {
          //   data: "status",
          //   title: OVERVIEW_META_DATA["LicensorLegalName"]["label"],
          //   width: "40px",
          //   render: function (data, type, row) {
          //      return row["items"]["LicensorLegalName"]["value"];
          //   }
          // },
          {
            data: "status",
            title: (OVERVIEW_META_DATA["startdate"]["label"]),
            width: "40px",
            render: function (data, type, row) {
               return row["items"]["startdate"]["value"];
            }
          },
          {
            data: "status",
            title: (OVERVIEW_META_DATA["expirationdate"]["label"]),
            width: "40px",
            render: function (data, type, row) {
               return row["items"]["expirationdate"]["value"];
            }
          },
          {
            data: "status",
            title: (capitalizeFirstLetterOfEachWord(OVERVIEW_META_DATA["sell-off period"]["label"])),
            width: "40px",
            render: function (data, type, row) {
               return row["items"]["sell-off period"]["value"] === "NA" ? row["items"]["sell-off period"]["value"] : row["items"]["sell-off period"]["value"]+" "+OVERVIEW_META_DATA["sell-off period"]["units"];
            }
          },
          {
            data: "status",
            title: (OVERVIEW_META_DATA["PayableContact"]["label"]),
            width: "40px",
            render: function (data, type, row) {
               return row["items"]["PayableContact"]["value"];
            }
          },
          { data: "importdate", title: "Imported Date", width: "10px" },
          { data: "importedby", title: "Imported By", width: "40px" },
          {
            title: "Actions",
            orderable: false, // Disable sorting for this column
            data: null,
            width: "60px", 
            createdCell: function (td, cellData, rowData, row, col) {
              // Clear the default HTML and replace it with React-rendered content
              ReactDOM.render(
                <>
                  <OverlayTrigger
                    placement="top"
                    trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                    overlay={<Tooltip id="view-top">View</Tooltip>}
                  >
                    <a href="javascript:void(0);" className="view-btn" data-id={rowData._id} data-name={rowData.FilePath} data-status={rowData.status.StatusCode}>
                      <i className="datatable-edit-icon"></i>
                    </a>
                  </OverlayTrigger>
                  &nbsp;
                  <OverlayTrigger
                    trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                    placement="top"
                    overlay={<Tooltip id="delte-top">Delete</Tooltip>}
                  >
                  <a href="javascript:void(0);" className="delete-btn" data-bs-toggle="modal"
                     data-bs-target="#confirmationModal" data-id={rowData._id} data-name={rowData.FilePath}>
                    <i className="datatable-delete-icon"></i>
                  </a></OverlayTrigger>
                  &nbsp;
                  <OverlayTrigger
                    trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                    placement="top"
                    overlay={<Tooltip id="askgenie-top">Ask Genie</Tooltip>}
                  >
                  <a href="javascript:void(0);" className="askgenie-btn" data-id={rowData._id} data-name={rowData.FilePath} data-status={rowData.status.StatusCode}>
                    <i className="datatable-askgenie-icon"></i>
                  </a></OverlayTrigger>
                </>,
                td // Render the content directly into the table cell
              );
            }
          }
        
        ],
        fixedColumns: {
          start: 1,
          end: 1
      },
        // fixedColumns: {
        //   leftColumns: 1,   // No columns fixed on the left
        //   rightColumns: 2   // Fixes 1 column on the right (Actions column)
        // },
        paging: true,
        searching: false,
        ordering: true,
        responsive: true,
        fixedHeader: true,
        language: {
          emptyTable: "No data found matching the filters",  // Custom message for no data
        },
      });

      $('.menu-icon').on('click', function() {
        // Adjust DataTable columns and redraw when the sidebar menu is toggled
        setTimeout(function() {
          table.columns.adjust().draw();
        }, 100); // Adjust the delay time based on your sidebar transition duration
      });

      // Attach click handlers again for view, delete, and askgenie buttons
      $("#contract_grid").on("click", ".view-btn", function () {
        const id = $(this).data("id");
        const name = $(this).data("name");
        const status = $(this).data("status");
        if(status==="Success" || status==="success"){
          handleView(id, name);
        }
      });

      $("#contract_grid").on("click", ".delete-btn", function () {

        handleDeleteShow()
        const id = $(this).data("id");
        const name = getFilenameFromURL($(this).data("name"));
        setTimeout(function() {
          $("#btn_delete").attr("data-id", id);
          $("#document_name").html(name);
        }, 200);
        
             });
  
      $("#contract_grid").on("click", ".askgenie-btn", function () {
        const id = $(this).data("id");
        const name = $(this).data("name");
        const status = $(this).data("status");
        if(status==="Success" || status==="success"){
          handleAskgenie(id, name);
        }
      });
      return () => {
        table.destroy(); // Clean up DataTable instance
      };
    }
  }, [filteredData]);





    // Search handler
    const handleSearch = (e) => {
      setSearchQuery(e.target.value);
      applyFilters(e.target.value, filters);
    };
  const [files, setFiles] = useState([]);
  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);
    if (droppedFiles[0]?.size > 2 * 1024 * 1024) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        documentFile: "File size must not exceed 2 MB.",
      }));
      return;
    }
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    setFormData((prev) => ({ ...prev, documentFile: droppedFiles[0] }));
    setErrors((prevErrors) => ({ ...prevErrors, documentFile: "" }));
  };

  const handleFileSelect = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const file = selectedFiles[0];
    if (file?.size > 2 * 1024 * 1024) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        documentFile: "File size must not exceed 2 MB.",
      }));
      return;
    }
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    setFormData((prev) => ({ ...prev, documentFile: file }));
    setErrors((prevErrors) => ({ ...prevErrors, documentFile: "" }));
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleSelectChange = (selectedOption, actionMeta) => {
    const { name } = actionMeta;
    setFormData((prev) => ({
      ...prev,
      [name]: selectedOption,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.licensor) newErrors.licensor = "Licensor is required.";
    if (!formData.contractNo) newErrors.contractNo = "Contract No is required.";
    if (!formData.documentType)
      newErrors.documentType = "Document Type is required.";
    // if (!formData.masterFile) newErrors.masterFile = "Master File is required.";
    if (!formData.documentType)
      newErrors.documentType = "Document Type is required.";
    if (
      formData.documentType === "Amendment" &&
      !formData.masterFile
    ) {
      newErrors.masterFile = "Master File is required for Master.";
    }

    if (!formData.documentFile) newErrors.documentFile = "Document File is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const saveDocuemnt = async (data) => {
    $("#uploaderror").html("")
    let authToken =  localStorage.getItem("jsondata")
    if (authToken) {
      const jsonData = JSON.parse(authToken);
      authToken = jsonData.accessToken || "";
   }
    // try {
      $("#process-loader").removeClass("d-none")
      const response = await axios.post(API_SERVER_URL+'contracts/',data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + authToken,
        },
      });
      if(response.data.code === API_SUCCESS_RESPONSE_CREATED_CODE){
        handleClose()
        fetchData()
      }else {
        $("#process-loader").addClass("d-none")
        $("#uploaderror").html(response.data.message)
      }
    // } catch (error) {
    //   console.error('Error uploading the file:', error);
    // }
    return;
  }
  
  const resetForm = (e) => {
    handleShow()
    setFiles([])
    setFormData(initialState); // Reset form fields to initial state
  }

  const handleSubmit = (e) => {
    const logged_user_name = getUsername();
    e.preventDefault();
    // $('#uploadcontract-modal').modal('hide');
    if (!validateForm()) return;
    $(".page_pro_load").show();
    // const uniqueId = `doc-${Math.random().toString(36).substr(2, 9)}`;
    // const uniqueId = Math.floor(100000000000 + Math.random() * 900000000000);
    const timestamp = Date.now();  // Current timestamp in milliseconds
    const randomDigits = Math.floor(Math.random() * 1000); // Generate 3 random digits (0-999)
    const uniqueId = "doc_"+parseInt(`${timestamp}${randomDigits}`.substr(0, 12)); // Concatenate and ensure 12 digits
    const formDataapi = new FormData();
    formDataapi.append('file',formData.documentFile);
    formDataapi.append('doc_id',uniqueId);
    formDataapi.append('contract_id',formData.contractNo);
    formDataapi.append('licensor',formData.licensor.value);
    formDataapi.append('document_type',formData.documentType.value);
    if(formData.documentType.value==="Amendment"){
      formDataapi.append('master_doc_id',formData.masterFile.value);
    }else {
      formDataapi.append('master_doc_id',"");
    }  
    formDataapi.append("username",logged_user_name);
    saveDocuemnt(formDataapi)
  };

  const handleFilterChange = (filterName, value) => {
    setFilters((prevState) => {
      const newFilters = { ...prevState, [filterName]: value };
      applyFilters(newFilters);
      return newFilters;
    });
  };

  const applyFilters = (newFilters) => {
    let filteredDataTemp = data;

      // Multi-select filter for Document Type
  if (newFilters.filterdocumentType && newFilters.filterdocumentType.length > 0) {
    const selectedDocumentTypes = newFilters.filterdocumentType.map(option => option.value);
    filteredDataTemp = filteredDataTemp.filter((doc) =>
      selectedDocumentTypes.some(type => doc.documenttype.includes(type))
    );
  }

  // Multi-select filter for Licensor
  if (newFilters.filterlicensor && newFilters.filterlicensor.length > 0) {
    const selectedLicensors = newFilters.filterlicensor.map(option => option.value);
    filteredDataTemp = filteredDataTemp.filter((doc) =>
      selectedLicensors.some(licensor => doc.licensor.includes(licensor))
    );
  }

  // Multi-select filter for Status
  if (newFilters.filterstatus && newFilters.filterstatus.length > 0) {
    const selectedStatuses = newFilters.filterstatus.map(option => option.value.toLowerCase());
    filteredDataTemp = filteredDataTemp.filter((doc) =>
      selectedStatuses.some(status => doc.status.StatusCode.toLowerCase().includes(status))
    );
  }

  // Filter for Expiry Date (assuming single date selection)
  // if (newFilters.filterexpiryDate) {
  //   filteredDataTemp = filteredDataTemp.filter(
  //     (doc) => doc.expiryDate && doc.expiryDate.includes(newFilters.filterexpiryDate)
  //   );
  // }


    if (newFilters.filterTextSearch) { // New filter for text search
      filteredDataTemp = filteredDataTemp.filter((doc) => 
        doc.BioworldDocumentNo.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.status.StatusCode.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.licensor.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc["items"]["LicensorLegalName"]["value"].toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc["items"]["startdate"]["value"].toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc["items"]["expirationdate"]["value"].toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc["items"]["sell-off period"]["value"].toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc["items"]["PayableContact"]["value"].toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.importedby.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.importdate.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase())
      // )
      );
    }

    setFilteredData(filteredDataTemp);
  };

  const resetFilters = () => {
    setSearchQuery('');
    setFilters({
      filterdocumentType: null,
      filterlicensor: null,
      filterexpiryDate: '',
      filterstatus: null
    });
    setFilteredData(data); // Reset to full data
  };


  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
          <div className="flex-grow-1" id="row_heading">
            <div className="page-title">Contract List</div>
            <p className="text-muted my-2 ff-secondary">
             Manage and view all your contract documents
            </p>
            <div id="app_err"></div>
          </div>
          <div className="row g-2 mb-4 mt-4" id="row_search">
            <div className="col-sm-10">
              <div className="search-box">
                <input
                  type="text"
                  className="form-control"
                  id="searchDocuments"
                  placeholder="Search Documents..."  // This should work as expected
                  onChange={(e) => handleFilterChange('filterTextSearch', e.target.value)}
                />
                <i className="grid-search">
                <CommonIcon iconName="Search" size={"14px"}  />
                </i>
              </div>
            </div>
            <div className="col-sm-auto ms-auto">
              <div className="list-grid-nav hstack gap-4">
                <button className="btn btn-light" onClick={fetchData}>
                <CommonIcon iconName="RefreshCw" size={"14px"} color={"#000"} />
                </button>
                <button onClick={resetForm}
                  className="btn btn-primary uploadcontract-modal"
                  data-bs-toggle="modal"
                  data-bs-target="#addmemberModal"
                >
                  <CommonIcon iconName="Upload" size={"14px"} color="#fff" /> Upload
                </button>
                <button
                  type="button"
                  id="dropdownMenuLink1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  className="d-none btn btn-soft-info btn-icon material-shadow-none fs-14"
                >
                  <i className="ri-more-2-fill"></i>
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                  <li>
                    <a className="dropdown-item" href="#">
                      Show All
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Show Last Week
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Show Last Month
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Show Last Year
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

      <div className="row" id="row_filter" >
      <div className="col-lg-1 mt-2">
      <CommonIcon iconName="Filter" size={"14px"}  /> Filters:
      </div>
      <div className="col-lg-3">
      <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option
            }}
            value={filters.filterdocumentType}
            onChange={(selectedOption) => handleFilterChange('filterdocumentType', selectedOption)}
            options={documentTypeOptions}
            placeholder="Document Type"
          />
      </div>
      <div className="col-lg-3">
      <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option
            }}
            value={filters.filterlicensor}
            onChange={(selectedOption) => handleFilterChange('filterlicensor', selectedOption)}
            options={licensorOptions}
            placeholder="Licensor"
          />
      </div>
      {/* <div className="col-lg-2 mb-2">
      <input
                      type="date"
                      name="Expiry Date"
                      className="form-control"
                      placeholder="Expiry Date"
                      onChange={(e) => handleFilterChange('filterexpiryDate', e.target.value)}
                    />
      </div> */}
      <div className="col-lg-3 mb-2">
      <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option
            }}
            value={filters.filterstatus}
            onChange={(selectedOption) => handleFilterChange('filterstatus', selectedOption)}
            options={statusoptions}
            placeholder="Status"
          />
          </div>
            {/* <div className="col-lg-1 mb-2">
           
                <button className="btn btn-light" onClick={resetFilters}>
                <CommonIcon iconName="FilterXIcon" size={"14px"} color={"#000"} />
                </button>
          
      </div> */}
      </div>
      </div>
          <div className="row">
            <div className="col-lg-12">
              {/* <div className="card">
                <div className="card-body"> */}
                  <div>
                    {/* DataTable */}
                    {loading ? (
                 <PageLoader />
            ) :  data.length > 0 ?
                (
                <div className="row  mt-4">
                  <div className="col-lg-12">
                    <table
                      id="contract_grid"
                      className="display"
                      style={{ width: "100%" }}
                    >
                      <thead>
                      </thead>
                    </table>
                  </div>
                </div>) : "" }
                  </div>
                </div>
              </div>
            {/* </div>
          </div> */}
        </div>
      </div>
      <div
        className="modal fade"
        id="addmemberModal"
        tabIndex="-1"
        aria-labelledby="addmemberModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content border-0">
            <div className="modal-header p-3 bg-warning-subtle">
              <h5 className="modal-title" id="addmemberModalLabel">
                Upload New Contract
              </h5>
              <button
                id="upload_model_close"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            {/* <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-lg-12">
                    <label className="form-label">Licensor</label>
                    <Select
                        name="licensor"
                        options={licensorOptions}
                        value={formData.licensor}
                        onChange={handleSelectChange}
                        placeholder="Select a Licensor"
                      />
                    {errors.licensor && <div className="text-danger">{errors.licensor}</div>}
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label">Contract No</label>
                    <input
                      type="text"
                      name="contractNo"
                      className="form-control"
                      value={formData.contractNo}
                      onChange={handleInputChange}
                    />
                    {errors.contractNo && <div className="text-danger">{errors.contractNo}</div>}
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label">Document Type</label>

                    <Select
            name="documentType"
            value={formData.documentType}
            onChange={handleSelectChange}
          options={documentTypeOptions}
          placeholder="Docuemnt Type"
        />
                   
                    {errors.documentType && <div className="text-danger">{errors.documentType}</div>}
                  </div>
                  { formData.documentType !== null && formData.documentType !== "" && formData.documentType.value === "Amendment" && (
                  <div className="col-lg-12">
                    <label className="form-label">Master File</label>

                      <Select
                        name="masterFile"
                        value={formData.masterFile}
                        onChange={handleSelectChange}
                        options={masterDocumentOptions}
                        placeholder="Select Master File"
                    />
                    {errors.masterFile && (
                      <div className="text-danger">{errors.masterFile}</div>
                    )}
                  </div>
                )}
                  <div className="col-lg-12">
                    <label className="form-label">Document File</label>
                    <div
                      className="dropzone"
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      style={{
                        border: "2px dashed #ddd",
                        padding: "20px",
                        textAlign: "center",
                      }}
                    >
                      <input
                        type="file"
                        id="fileInput"
                        style={{ display: "none" }}
                        onChange={handleFileSelect}
                        accept="application/pdf"
                      />
                      <div className="mb-3">
                        <i className="display-4 text-muted">
                        <CommonIcon iconName="Upload" size={"34px"} />
                        </i>
                      </div>
                      <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
                        Drop files here or click to upload
                      </label>
                    </div>
                    <ul style={{ marginTop: "20px" }}>
                    {files.map((file, index) => (
                    <span>{file.name}</span>
                    ))}
                  </ul>
                    {errors.documentFile && <div className="text-danger">{errors.documentFile}</div>}
                  </div>
                <div className="page_pro_load mb-2">{processLoader("Uploading PDF inprogress, please wait....")}</div>
                <div id="uploaderror"></div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-light" data-bs-dismiss="modal"><i className="ri-close-line align-bottom me-1"></i> Close</button>
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div>
              </form>
            </div> */}
          </div>
        </div>
      </div>


      <Modal show={deletedocumentmodal} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title><div className="page-title" id="confirmationModalLabel">
                Delete
              </div></Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <label class="form-label">Are you sure want to delete <span id="document_name"></span> document?</label>
          </Modal.Body>
        <Modal.Footer>
        <button type="button" onClick={handleDeleteClose} className="btn btn-light" data-bs-dismiss="modal"><CommonIcon iconName="X" size={"14px"} /> Close</button>
                  <button onClick={handleDelete} id="btn_delete" data-id="1111" type="submit" className="btn btn-primary">
                    <CommonIcon iconName="Trash" size={"14px"} color="#fff" /> Delete
                  </button>
        </Modal.Footer>
      </Modal>



      <Modal show={adddocumentmodal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> 
                Upload New Contract
           </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-lg-12">
                    <label className="form-label">Licensor</label>
                    <Select
                        name="licensor"
                        options={licensorOptions}
                        value={formData.licensor}
                        onChange={handleSelectChange}
                        placeholder="Select a Licensor"
                      />
                    {errors.licensor && <div className="text-danger">{errors.licensor}</div>}
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label">Contract No</label>
                    <input
                      type="text"
                      name="contractNo"
                      className="form-control"
                      value={formData.contractNo}
                      onChange={handleInputChange}
                    />
                    {errors.contractNo && <div className="text-danger">{errors.contractNo}</div>}
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label">Document Type</label>

                    <Select
            name="documentType"
            value={formData.documentType}
            onChange={handleSelectChange}
          options={documentTypeOptions}
          placeholder="Docuemnt Type"
        />
                   
                    {errors.documentType && <div className="text-danger">{errors.documentType}</div>}
                  </div>
                  { formData.documentType !== null && formData.documentType !== "" && formData.documentType.value === "Amendment" && (
                  <div className="col-lg-12">
                    <label className="form-label">Master File</label>

                      <Select
                        name="masterFile"
                        value={formData.masterFile}
                        onChange={handleSelectChange}
                        options={masterDocumentOptions}
                        placeholder="Select Master File"
                    />
                    {errors.masterFile && (
                      <div className="text-danger">{errors.masterFile}</div>
                    )}
                  </div>
                )}
                  <div className="col-lg-12">
                    <label className="form-label">Document File</label>
                    <div
                      className="dropzone"
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      style={{
                        border: "2px dashed #ddd",
                        padding: "20px",
                        textAlign: "center",
                      }}
                    >
                      <input
                        type="file"
                        id="fileInput"
                        style={{ display: "none" }}
                        onChange={handleFileSelect}
                        accept="application/pdf"
                      />
                      <div className="mb-3">
                        <i className="display-4 text-muted">
                        <CommonIcon iconName="Upload" size={"34px"} />
                        </i>
                      </div>
                      <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
                        Drop files here or click to upload
                      </label>
                    </div>
                    <ul style={{ marginTop: "20px",wordBreak:"break-all" }}>
                    {files.map((file, index) => (
                    <span>{file.name}</span>
                    ))}
                  </ul>
                    {errors.documentFile && <div className="text-danger">{errors.documentFile}</div>}
                  </div>
                <div className="page_pro_load mb-2">{
                <ProcessLoader pmMessage={"PDF upload in progress, please wait..."}  />
                }</div>
                <div id="uploaderror"></div>
                </div>
                {/* <div className="modal-footer">
                  <button type="button" className="btn btn-light" data-bs-dismiss="modal"><i className="ri-close-line align-bottom me-1"></i> Close</button>
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                </div> */}
              </form>
            </div>
        </Modal.Body>
        <Modal.Footer>
        <button type="button" onClick={handleClose} className="btn btn-light" data-bs-dismiss="modal"><i className="ri-close-line align-bottom me-1"></i> Close</button>
              <button onClick={handleSubmit} type="submit" className="btn btn-primary">
                    Save
               </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};